import type { ReactNode } from 'react';
import { Svg } from '../primitives/Svg.js';
import type { IconProps } from '../primitives/types.js';

/** Quote — two stylised typographic quotation marks. Reads as the
 *  block-quote insert affordance; distinct from `IcnComment` which
 *  signals reader / collaborator commentary. */
export function IcnQuote(props: IconProps): ReactNode {
  return (
    <Svg {...props} iconName="quote">
      <path d="M3 5h2a2 2 0 0 1 0 4H4v2H3V5z" />
      <path d="M9 5h2a2 2 0 0 1 0 4h-1v2H9V5z" />
    </Svg>
  );
}
